import { ImagesService } from '@services/image-service';
import { State } from '@components/orders-sales/type';
import { Product } from '@interfaces/models/orderSaleProduct';
import React from 'react';
import { URL_QUERIES } from '@constants/orders-sales';

const defaultImage = ImagesService.buildUrl(`/notFound/placeholder.jpg`, { w: 56, h: 56 }, false);

export const taxUrl = 'https://www.impots.gouv.fr/portail/node/10841';

export function helpCenterUrl(str: string): string {
  const language = str === 'en-GB' || str === 'en-US' ? str.toLowerCase() : str.split('-')[0].toLowerCase();
  return `https://faq.vestiairecollective.com/hc/${language}`;
}

export function chatUrl(partnerId: string, productId: string): string {
  return `/chat/?id=${partnerId}-${productId}`;
}

export function productImage(name: string): string {
  return `${ImagesService.buildUrl(`/produit/${name}`, { w: 100, h: 100 }, true)}`;
}

export function onImageError(event: React.SyntheticEvent<HTMLImageElement, Event>) {
  event.currentTarget.onerror = null;
  event.currentTarget.src = defaultImage;
}

export function filterProducts(products: Product[], shippingProduct: Product | null): Product[] {
  const result: Product[] = products || [];

  if (!shippingProduct) {
    return result;
  }

  return [shippingProduct, ...result.filter(({ productId }) => shippingProduct.productId !== productId)];
}

export function getCurrentProduct({ currentTab, orderProduct, saleProduct }: State): Product | null {
  return currentTab === 'Order' && orderProduct ? orderProduct[1] : saleProduct;
}

export function hasSelected({ currentTab, orderProduct, saleProduct }: State): boolean | null {
  return currentTab === 'Order' ? orderProduct != null : saleProduct != null;
}

const setQueryParam = (params: URLSearchParams, name: string, value: string) => {
  if (!value) {
    params.delete(name);
    return;
  }
  if (params.get(name)) {
    params.set(name, value);
  } else {
    params.append(name, value);
  }
};

export function updateURLQueries(
  path: string,
  params?: { section?: string; productId?: string; orderId?: string; waitingToShipProduct?: string },
) {
  if (!params) {
    window.history.replaceState(null, '', path);
    return;
  }

  const searchQueries = new URLSearchParams(window.location.search);

  Object.keys(params).forEach((key) => {
    setQueryParam(searchQueries, key, params[key] as string);
  });

  window.history.replaceState(null, '', `${path}/?${searchQueries}`);
}

export const getOrderSaleURLQueries = () => {
  if (typeof window !== 'undefined') {
    const queries = new URLSearchParams(window.location.search);

    return {
      section: queries.get(URL_QUERIES.section),
      orderId: queries.get(URL_QUERIES.orderId),

      // Used for bookmarked, check to put this product ID on top of the product list
      productId: queries.get(URL_QUERIES.productId),

      // Used in Shipping Reminder,
      // when user click from Order tab to Sale tab -> open Get Shipping Label automatically
      waitingToShipProduct: queries.get(URL_QUERIES.waitingToShipProduct),
    };
  }

  return {};
};

export const mainPageId = 'ordersSalesMainPage';
export const saleListingId = 'ordersSalesSaleListing';
export const stepsId = 'ordersSalesSteps';
export const currentStepId = 'ordersSalesCurrentStep';
